import React from "react";
import { withStyles } from '@material-ui/core/styles';

import MuiDrawer from '@material-ui/core/Drawer';

const drawerWidth = 300;
const drawerWidthSmall = 60;

const Drawer = ({ classes, children }) => (
    <MuiDrawer
        variant="permanent"
        classes={{ paper: classes.drawerPaper }}
    >
        <div className={classes.toolbarSpacer} />
        {children}
    </MuiDrawer>
);

const styles = theme => ({
    toolbarSpacer: theme.mixins.toolbar,
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        [theme.breakpoints.down("sm")]: {
            width: drawerWidthSmall
        },
    },
});

export default withStyles(styles)(Drawer);